module.exports = __webpack_public_path__ + "img/hw-bg4.5a19da1f.png";